import { useNavigate } from "react-router-dom";

import axios from 'axios';
import Storages from '../helper/storages'
import useEndpoints from "../api/useEndpoints";
import errorHandler from "../api/errorHandler";
import { useState, useRef, useEffect } from "react";

import Toast from './toast'
import paths from './../config/paths.json'

import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai'
import Captcha from "./captcha";
import initUserInfo from "../api/initUserInfo";
import LoginHeader from "./loginHeader";
import { fa2En } from '../helper/InputHelper'
import { useMediaQuery } from 'react-responsive'

export default function Login() {
  const endpoints = useEndpoints();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false)
  const [state, setState] = useState({ username: Storages.getUserName(), password: Storages.getUserPass() })
  const [loading, setLoading] = useState(false)
  const [challengeId, setChallengeId] = useState()
  const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
  console.log('ssssssssssssssssss', process.env.REACT_APP_ENV)
  var logo = require(`../assets/images/${process.env.REACT_APP_ENV}/logo.png`)
  var bg_lg = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-lg.jpg`)
  var bg_sm = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-sm.jpg`)

  var onLoginPress = () => {

    setLoading(true)
    axios.get(endpoints.login,
      {
        params:
        {
          username: fa2En(state?.username),
          password: state?.password,
          challengeId: challengeId
        }
      }, {
      headers: { 'x-auth-token': Storages.getUserToken() },
    }).then((res) => {
      setLoading(false)
      Storages.setUserName(state?.username)
      Storages.setUserPass(state?.password)
      if (res.data.result.twoStepVerify == 1) {
        Storages.setHashedPhoneNumber(res.data.result.phoneNumber)
        Storages.setAllowReqAfterSec(new Date().getTime() + (res.data.result.allowReqAfterSec * 1000))
        Toast.Success("کد تایید برای شما ارسال شد")
        navigate(paths.loginVerify);
      } else {
        initUserInfo(res.data.result.userInfo)
        navigate(paths.dashboard)
      }
    }).catch((e) => {
      setLoading(false)
      errorHandler(e)
    })
  }


  var [base, setBase] = useState({})

  var baseInfo = () => {

    setLoading(true)
    axios.get(endpoints.baseInfo,
      {
        params: {}
      }, {
      headers: {},
    }).then((res) => {
      setLoading(false)
      setBase(res?.data?.result)
    }).catch((e) => {
      setLoading(false)
      errorHandler(e)
    })
  }


  useEffect(() => {
    baseInfo()
    setChallengeId('ssssssssss')

  }, [])

  let onInputChange = (e) => {

    try {
      let name = e.target.name;
      let value = e.target.value;
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } catch (e) {
      console.log(e);
    }
  };

  var submit = useRef()
  var password = useRef()

  return (

    <div >

      <div className="d-flex justify-content-center align-items-center  vh-100 overflow-auto bg-danger position-relative " style={{ top: 0, right: 0, bottom: 0, left: 0 }} >

        <div className="w-100 vh-100 position-absolute bg-dark align-items-center overflow-hidden  justify-content-center d-flex ">
          {
            isMobile ?
              <img className="center-cropped " src={bg_sm} />
              :
              <img className="  center-cropped " src={bg_lg} />


          }

        </div>

        <div className="d-flex flex-column justify-content-center align-items-center col-10  col-sm-6 col-md-5 col-lg-3 ">



          <div className="card p-3 col-12 " autoComplete="on"  >
            <div className="d-flex w-100 justify-content-center align-items-center trans ">
              <img style={{ width: '9rem' }} className="position-absolute top-0 mt-2 start-50 translate-middle" src={logo} />
            </div>

            <h5 className="justify-content-center align-items-center d-flex iranSansBold mt-5">صفحه ورود</h5>

            <div className="form-group pt-4 autocomp">
              <label htmlFor="username" className="pb-1">نام کاربری</label>
              <input type="number"
                className="form-control"
                name="username"
                value={state?.username}
                placeholder="نام کاربری"
                onChange={onInputChange}
                onKeyDown={(e) => { if (e.key.toLowerCase() === "enter") password.current.focus() }} />
            </div>

            <div className="form-group pt-2">
              <label htmlFor="password" className="pb-1">کلمه عبور</label>
              <div className="d-flex flex-row-reverse align-items-center " >
                <input type={showPassword ? "text" : "password"}
                  onKeyDown={(e) => { if (e.key.toLowerCase() === "enter") submit.current.focus() }}
                  className="form-control" ref={password}
                  name="password"
                  placeholder="کلمه عبور"
                  onChange={onInputChange}
                  value={state?.password}
                />
                <div className="position-absolute ms-3"
                  onClick={() =>
                    setShowPassword(!showPassword)}>
                  {showPassword ?
                    <AiOutlineEye className="text-dark" />
                    :
                    <AiOutlineEyeInvisible className="text-dark" />
                  }
                </div>
              </div>
            </div>

            {/* <div className="form-check pt-2 invisible">
              <input type="checkbox" id="saveCheck" />
              <label className="form-check-label p-1" htmlFor="saveCheck">مرا به خاطر بسپار</label>
            </div> */}

            {/* <div className="col-12  justify-content-center align-items-center d-flex mt-2">
              <Captcha onChallengeId={setChallengeId} />
            </div> */}

            {
              loading ?
                <div className="col-12  justify-content-center align-items-center d-flex mt-2">
                  <div className="spinner-border text-primary " />
                </div>
                :
                <div>

                  <div>
                    <label className="form-check-label p-1 mt-2 text-success   "
                      style={{ cursor: 'pointer' }}
                      htmlFor="saveCheck"
                      onClick={() => { navigate(paths.recoveryRassword) }}>رمز عبورم را فراموش کردم</label>
                  </div>
                  <button to="/"
                    ref={submit}
                    className="btn btn-success iranSansBold col-12 mt-2 arcaptcha"
                    onClick={onLoginPress}
                  >ورود به پنل سازمانی</button>

                </div>

            }


            <div className="mt-2">
              <label className="form-check-label px-1 my-0 mt-1  "
                style={{ cursor: 'pointer' }}
                htmlFor="saveCheck"
                onClick={() => { navigate(paths.register) }}>تا کنون اشتراکی نداشته اید؟</label>
              <label className="form-check-label px-1 my-0 mt-1 text-success iranSansBold  "
                style={{ cursor: 'pointer' }}
                htmlFor="saveCheck"
                onClick={() => { navigate(paths.register) }}>ایجاد اشتراک </label>
            </div>
            <div>
              <label className="form-check-label p-1 text-success   "
                style={{ cursor: 'pointer' }}
                htmlFor="saveCheck"
                onClick={() => {
                  window.open(base?.privacy, "_blank", "noreferrer");
                }
                }>مطالعه شرایط و قوانین</label>
            </div>
          </div>
          <a href={base.learningPanelUrl} target="_blank" className="col-12 mt-3" style={{ zIndex: '1000' }}>

            <button
              className="btn btn-warning iranSansBold col-12"
              onClick={() => {
                window.open(base?.learningPanelUrl, "_blank", "noreferrer");
              }}> آموزش پنل سازمانی

            </button>
          </a>
          <h4 className="form-text text-white text-shadow" style={{ zIndex: '1000', textShadow: '2px 2px #000000' }}>
          </h4>

        </div>

        <small className="form-text text-white text-shadow position-absolute bottom-0 start-50 translate-middle-x opacity-75" style={{ zIndex: '1000', textShadow: '2px 2px #000000' }}>1401 © توسعه و اجرا توسط شرکت <a href="http://efspco.ir" target="_blank" className="">ابتکار فناوران سهند پویا</a> </small>

      </div>
    </div>

  );

}